import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

export default function PrivacyPolicy() {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <Link to="/login" className="legal-back">
          ← חזרה להתחברות
        </Link>

        <h1>מדיניות פרטיות</h1>
        <p className="legal-updated">עודכן לאחרונה: דצמבר 2024</p>

        <section>
          <h2>1. מבוא</h2>
          <p>
            כתב כמויות מחויבת להגנה על פרטיותך. מדיניות פרטיות זו מסבירה כיצד אנו אוספים, משתמשים
            ומגנים על המידע שלך כאשר אתה משתמש בשירות שלנו.
          </p>
        </section>

        <section>
          <h2>2. מידע שאנו אוספים</h2>
          <h3>מידע שאתה מספק לנו:</h3>
          <ul>
            <li>פרטי הרשמה: שם, כתובת דואר אלקטרוני, מספר טלפון</li>
            <li>פרטי פרויקט: כתובת הנכס, תקציב, מידע על חללים ופריטים</li>
            <li>מידע על ספקים וקבלנים שאתה מוסיף למערכת</li>
            <li>תכתובות ותקשורת עם צוות התמיכה שלנו</li>
          </ul>

          <h3>מידע שנאסף אוטומטית:</h3>
          <ul>
            <li>כתובת IP ומידע על המכשיר</li>
            <li>נתוני שימוש ופעילות באתר</li>
            <li>עוגיות (Cookies) ומזהים דומים</li>
          </ul>
        </section>

        <section>
          <h2>3. כיצד אנו משתמשים במידע</h2>
          <p>אנו משתמשים במידע שנאסף למטרות הבאות:</p>
          <ul>
            <li>אספקת השירות וניהול חשבונך</li>
            <li>שיפור וייעול השירות</li>
            <li>תקשורת עמך בנוגע לשירות, עדכונים והודעות</li>
            <li>אבטחת השירות ומניעת הונאות</li>
            <li>עמידה בדרישות חוקיות</li>
          </ul>
        </section>

        <section>
          <h2>4. שיתוף מידע</h2>
          <p>איננו מוכרים את המידע האישי שלך. אנו עשויים לשתף מידע במקרים הבאים:</p>
          <ul>
            <li>עם ספקי שירות הפועלים מטעמנו (אחסון, ניתוח נתונים)</li>
            <li>כאשר נדרש על פי חוק או צו בית משפט</li>
            <li>להגנה על זכויותינו או בטיחות המשתמשים</li>
            <li>במקרה של מיזוג או רכישה של החברה</li>
          </ul>
        </section>

        <section>
          <h2>5. אבטחת מידע</h2>
          <p>
            אנו נוקטים באמצעי אבטחה סבירים להגנה על המידע שלך, כולל הצפנה, בקרת גישה ואחסון מאובטח.
            עם זאת, אין שיטת העברה או אחסון באינטרנט שהיא מאובטחת ב-100%.
          </p>
        </section>

        <section>
          <h2>6. שמירת מידע</h2>
          <p>
            אנו שומרים את המידע שלך כל עוד חשבונך פעיל או כנדרש לאספקת השירות. לאחר סגירת החשבון,
            נשמור מידע מסוים לתקופה סבירה לצורך עמידה בדרישות חוקיות ויישוב מחלוקות.
          </p>
        </section>

        <section>
          <h2>7. הזכויות שלך</h2>
          <p>יש לך את הזכויות הבאות בנוגע למידע שלך:</p>
          <ul>
            <li>גישה למידע האישי שלך</li>
            <li>תיקון מידע לא מדויק</li>
            <li>מחיקת המידע שלך (בכפוף למגבלות חוקיות)</li>
            <li>התנגדות לעיבוד מסוים של המידע</li>
            <li>העברת המידע שלך (ניידות נתונים)</li>
          </ul>
          <p>לממש זכויות אלה, פנה אלינו בכתובת המייל המופיעה למטה.</p>
        </section>

        <section>
          <h2>8. עוגיות (Cookies)</h2>
          <p>
            אנו משתמשים בעוגיות ובטכנולוגיות דומות לשיפור חוויית המשתמש, לניתוח שימוש ולהתאמה אישית.
            תוכל לנהל את העדפות העוגיות דרך הגדרות הדפדפן שלך.
          </p>
        </section>

        <section>
          <h2>9. שינויים במדיניות</h2>
          <p>
            אנו עשויים לעדכן מדיניות זו מעת לעת. שינויים מהותיים יפורסמו באתר ותקבל הודעה בדואר
            אלקטרוני. המשך השימוש בשירות לאחר השינויים מהווה הסכמה למדיניות המעודכנת.
          </p>
        </section>

        <section>
          <h2>10. יצירת קשר</h2>
          <p>לשאלות או בקשות בנוגע למדיניות פרטיות זו או למידע האישי שלך, ניתן לפנות אלינו:</p>
          <p>דואר אלקטרוני: privacy@ktav-kamuyot.co.il</p>
        </section>
      </div>
    </div>
  );
}
